import Vue from 'vue'
import { gsap } from 'gsap'
import vuetify from './plugins/vuetify'

import { globe, setGlobe } from './animations/globe'
import loader from './animations/loader'
import { title, button, setTitle, setParagraph } from './animations/home'
import { animateLogo, setLogo } from './animations/logo'
import { nav, setNav } from './animations/nav'

export default new Vue({
  data () {
    return {
      shouldHomeLoaderRun: false,
      thePreloader: null,
      globe: null,
      home: null,
      logo: null,
      nav: null
    }
  },
  methods: {
    registerComponent (name, component) {
      if (this.shouldHomeLoaderRun) {
        this[name] = component
        // Set defaults:
        var tl = gsap.timeline()
        switch (name) {
          case 'home':
            tl.add(setTitle(this.home))
            if (this.$vuetify.breakpoint.smAndDown) {
              tl.add(setParagraph(this.home))
            }
            break
          case 'logo':
            tl.add(setLogo(this.logo))
            break
          case 'globe':
            tl.add(setGlobe(this.globe))
            break
          case 'nav':
            tl.add(setNav(this.nav))
            break

          default:
            break
        }

        if (
          this.shouldHomeLoaderRun &&
          this.thePreloader &&
          this.globe &&
          this.home &&
          this.logo &&
          this.nav
        ) {
          this.triggerLoader()
        }
      }
    },
    triggerLoader () {
      var tl = gsap.timeline()
      tl.add(loader(this.thePreloader))
      tl.add(globe(this.globe), '-=0.5')
      tl.add(title(this.home), '-=0.5')
      console.log(this.$vuetify.breakpoint.mdAndUp)
      if (this.$vuetify.breakpoint.mdAndUp) { // Desktop
        tl.add(animateLogo(this.logo), '-=0.5')
        tl.add(nav(this.nav), '-=0.5')
        tl.add(button(this.home), '-=0.5')
      } else { // Mobile
        tl.add(animateLogo(this.logo), '-=0.5')
        tl.add(button(this.home), '-=0.5')
        tl.add(nav(this.nav), '-=1')
      }
    },
    setShouldHomeLoaderRun (value) {
      this.shouldHomeLoaderRun = value
    }
  },
  vuetify
})
